module.exports = __webpack_public_path__ + "static/media/bonjour_large.5c15bb87.png";